/**
 * RoomStatus 双缓存：房型列表永久，房型信息 1 分钟，平均价按当天
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getRoomStatusFromThirdParty, getAvgPriceByDate } from '../../../../service/storeRevenueApi';
import { buildRoomStatusFromListAndData, splitFsmItems, } from '../../../utils/fsmToRoomStatus';
import { getStoreFromLocalStorage, setStoreSliceInLocalStorage } from '../../../utils/storeRevenueLocalStorage';
var ROOM_DATA_TTL_MS = 1 * 60 * 1000;
var HOURLY_PRICE_NODES = 12;
var PRICE_HISTORY_MAX_AGE_MS = 24 * 60 * 60 * 1000;
function roundTwo(v) {
    return Math.round(v * 100) / 100;
}
var priceHistoryCache = new Map();
function ensurePriceHistoryForKey(key) {
    var perHotel = priceHistoryCache.get(key);
    if (!perHotel) {
        perHotel = new Map();
        priceHistoryCache.set(key, perHotel);
    }
    return perHotel;
}
function ensureSlotsForRoom(perHotel, roomTypeId) {
    var _a;
    var slots = perHotel.get(roomTypeId);
    if (((_a = slots === null || slots === void 0 ? void 0 : slots.length) !== null && _a !== void 0 ? _a : 0) !== HOURLY_PRICE_NODES) {
        slots = Array.from({ length: HOURLY_PRICE_NODES }, function () { return []; });
        perHotel.set(roomTypeId, slots);
    }
    return slots;
}
function appendPriceHistory(key, byId) {
    var _a;
    var now = Date.now();
    var slotIndex = new Date().getHours() % HOURLY_PRICE_NODES;
    var cutoff = now - PRICE_HISTORY_MAX_AGE_MS;
    var perHotel = ensurePriceHistoryForKey(key);
    for (var _i = 0, _b = Object.entries(byId); _i < _b.length; _i++) {
        var _c = _b[_i], roomTypeId = _c[0], d = _c[1];
        var id = Number(roomTypeId);
        if (Number.isNaN(id))
            continue;
        var slots = ensureSlotsForRoom(perHotel, id);
        var price = roundTwo((_a = d.dayPrice) !== null && _a !== void 0 ? _a : 0);
        slots[slotIndex].push({ price: price, time: now });
        slots[slotIndex] = slots[slotIndex].filter(function (p) { return p.time >= cutoff; });
    }
}
function getTodayYYYYMMDD() {
    var d = new Date();
    return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'));
}
function getLastYearTodayAndSevenDaysAgo() {
    var d = new Date();
    var lastYear = new Date(d);
    lastYear.setFullYear(d.getFullYear() - 1);
    var seven = new Date(d);
    seven.setDate(d.getDate() - 7);
    var fmt = function (x) {
        return "".concat(x.getFullYear(), "-").concat(String(x.getMonth() + 1).padStart(2, '0'), "-").concat(String(x.getDate()).padStart(2, '0'));
    };
    return { lastYearToday: fmt(lastYear), sevenDaysAgo: fmt(seven) };
}
var avgPriceRefsCache = new Map();
var inFlightAvgRefs = new Map();
export function getAvgPriceRefsForRoomStatus(hotelId) {
    return __awaiter(this, void 0, Promise, function () {
        var today, cacheKeyAvg, cached, inFlight, promise;
        var _this = this;
        return __generator(this, function (_a) {
            today = getTodayYYYYMMDD();
            cacheKeyAvg = "avgPriceRefs:".concat(String(hotelId), ":").concat(today);
            cached = avgPriceRefsCache.get(cacheKeyAvg);
            if (cached)
                return [2 /*return*/, cached];
            inFlight = inFlightAvgRefs.get(cacheKeyAvg);
            if (inFlight)
                return [2 /*return*/, inFlight];
            promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, date1, date2, _b, lastYearToday, sevenDaysAgo, refs;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = getLastYearTodayAndSevenDaysAgo(), date1 = _a.lastYearToday, date2 = _a.sevenDaysAgo;
                            return [4 /*yield*/, Promise.all([
                                    getAvgPriceByDate(hotelId, date1),
                                    getAvgPriceByDate(hotelId, date2),
                                ])];
                        case 1:
                            _b = _c.sent(), lastYearToday = _b[0], sevenDaysAgo = _b[1];
                            refs = { lastYearToday: lastYearToday, sevenDaysAgo: sevenDaysAgo };
                            avgPriceRefsCache.set(cacheKeyAvg, refs);
                            return [2 /*return*/, refs];
                    }
                });
            }); })().finally(function () { inFlightAvgRefs.delete(cacheKeyAvg); });
            inFlightAvgRefs.set(cacheKeyAvg, promise);
            return [2 /*return*/, promise];
        });
    });
}
var roomTypeListCache = new Map();
var roomDataCache = new Map();
function cacheKey(hotelId) {
    return "roomStatus:".concat(String(hotelId));
}
function isDataValid(entry) {
    return Date.now() - entry.fetchedAt < ROOM_DATA_TTL_MS;
}
var inFlightRoomStatus = new Map();
/** 冷启动从 localStorage 恢复：若有有效数据（1 分钟内）则同步返回，供 hook 做初始渲染 */
export function getRoomStatusFromLocalStorageSync(hotelId) {
    var _a;
    var stored = (_a = getStoreFromLocalStorage(hotelId)) === null || _a === void 0 ? void 0 : _a.roomStatus;
    if (!(stored === null || stored === void 0 ? void 0 : stored.data) || typeof stored.fetchedAt !== 'number')
        return null;
    if (Date.now() - stored.fetchedAt > ROOM_DATA_TTL_MS)
        return null;
    var d = stored.data;
    if (!d || typeof d !== 'object' || !Array.isArray(d.dataSource))
        return null;
    return d;
}
export function getRoomStatusWithCache(hotelId, fallback) {
    return __awaiter(this, void 0, Promise, function () {
        var key, list, dataEntry, buildWithRefs, fromLocal, inFlight, promise;
        var _this = this;
        return __generator(this, function (_a) {
            key = cacheKey(hotelId);
            list = roomTypeListCache.get(key);
            dataEntry = roomDataCache.get(key);
            buildWithRefs = function () { return __awaiter(_this, void 0, Promise, function () {
                var refs, _a, priceHistory;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getAvgPriceRefsForRoomStatus(hotelId)];
                        case 1:
                            refs = _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _a = _b.sent();
                            refs = {
                                lastYearToday: { date: getLastYearTodayAndSevenDaysAgo().lastYearToday, avgPrice: 0 },
                                sevenDaysAgo: { date: getLastYearTodayAndSevenDaysAgo().sevenDaysAgo, avgPrice: 0 },
                            };
                            return [3 /*break*/, 3];
                        case 3:
                            priceHistory = priceHistoryCache.get(key);
                            return [2 /*return*/, buildRoomStatusFromListAndData(list, dataEntry.byId, refs, priceHistory)];
                    }
                });
            }); };
            if (dataEntry && isDataValid(dataEntry) && list && list.length > 0) {
                return [2 /*return*/, buildWithRefs()];
            }
            fromLocal = getRoomStatusFromLocalStorageSync(hotelId);
            if (fromLocal != null)
                return [2 /*return*/, fromLocal];
            inFlight = inFlightRoomStatus.get(key);
            if (inFlight)
                return [2 /*return*/, inFlight];
            promise = (function () { return __awaiter(_this, void 0, Promise, function () {
                var fsmItems, _a, roomTypeList, byId, refs, _b, priceHistory, result, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 6, , 7]);
                            return [4 /*yield*/, getRoomStatusFromThirdParty(hotelId)];
                        case 1:
                            fsmItems = _d.sent();
                            if (!fsmItems.length)
                                return [2 /*return*/, fallback];
                            _a = splitFsmItems(fsmItems), roomTypeList = _a.roomTypeList, byId = _a.byId;
                            if (!roomTypeListCache.has(key))
                                roomTypeListCache.set(key, roomTypeList);
                            roomDataCache.set(key, { byId: byId, fetchedAt: Date.now() });
                            appendPriceHistory(key, byId);
                            refs = void 0;
                            _d.label = 2;
                        case 2:
                            _d.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, getAvgPriceRefsForRoomStatus(hotelId)];
                        case 3:
                            refs = _d.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            _b = _d.sent();
                            refs = {
                                lastYearToday: { date: getLastYearTodayAndSevenDaysAgo().lastYearToday, avgPrice: 0 },
                                sevenDaysAgo: { date: getLastYearTodayAndSevenDaysAgo().sevenDaysAgo, avgPrice: 0 },
                            };
                            return [3 /*break*/, 5];
                        case 5:
                            priceHistory = priceHistoryCache.get(key);
                            result = buildRoomStatusFromListAndData(roomTypeList, byId, refs, priceHistory);
                            setStoreSliceInLocalStorage(hotelId, 'roomStatus', { data: result, fetchedAt: Date.now() });
                            return [2 /*return*/, result];
                        case 6:
                            _c = _d.sent();
                            if (list && list.length > 0 && dataEntry)
                                return [2 /*return*/, buildWithRefs()];
                            return [2 /*return*/, fallback];
                        case 7: return [2 /*return*/];
                    }
                });
            }); })().finally(function () { inFlightRoomStatus.delete(key); });
            inFlightRoomStatus.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
export function clearRoomStatusCache(hotelId) {
    var key = cacheKey(hotelId);
    roomTypeListCache.delete(key);
    roomDataCache.delete(key);
    priceHistoryCache.delete(key);
    var today = getTodayYYYYMMDD();
    avgPriceRefsCache.delete("avgPriceRefs:".concat(String(hotelId), ":").concat(today));
    inFlightRoomStatus.delete(key);
    inFlightAvgRefs.delete("avgPriceRefs:".concat(String(hotelId), ":").concat(today));
}
export function __getRoomStatusCachesForDev() {
    return { roomTypeListCache: roomTypeListCache, roomDataCache: roomDataCache, avgPriceRefsCache: avgPriceRefsCache };
}
